import { useMemo, type FC } from 'react';

import { Icon, Text } from '@livechat/design-system-react-components';
import { CheckCircle, Error as ErrorIcon } from '@livechat/design-system-icons';

import { validatePasswordRequirements } from 'helpers/validators/password';
import * as styles from './styles';

type Props = {
  password: string | undefined;
  showErrors: boolean;
};

export const PasswordRequirements: FC<Props> = ({ password, showErrors }) => {
  const { hasCapitalLetter, hasMinLength, hasNumber, hasSpecialChar } = useMemo(
    () => validatePasswordRequirements(password),
    [password]
  );

  return (
    <div css={styles.requirementsContainer}>
      <div css={styles.requirementsColumn}>
        <Text
          css={styles.requirement(hasMinLength, showErrors)}
          data-testid="min-length-requirement"
        >
          <Icon source={!showErrors || hasMinLength ? CheckCircle : ErrorIcon} size="small" />
          min. 12 characters
        </Text>
        <Text css={styles.requirement(hasNumber, showErrors)} data-testid="min-number-requirement">
          <Icon source={!showErrors || hasNumber ? CheckCircle : ErrorIcon} size="small" />
          min. 1 number
        </Text>
      </div>
      <div css={styles.requirementsColumn}>
        <Text
          css={styles.requirement(hasSpecialChar, showErrors)}
          data-testid="min-special-char-requirement"
        >
          <Icon source={!showErrors || hasSpecialChar ? CheckCircle : ErrorIcon} size="small" />
          min. 1 special character
        </Text>
        <Text
          css={styles.requirement(hasCapitalLetter, showErrors)}
          data-testid="min-capital-letter-requirement"
        >
          <Icon source={!showErrors || hasCapitalLetter ? CheckCircle : ErrorIcon} size="small" />
          min. 1 uppercase letter
        </Text>
      </div>
    </div>
  );
};
